import Card from "components/card";
import React from "react";

const General = () => {
  return (
    <Card extra={"w-full h-full p-3"}>
      {/* Header */}
      <div className="mt-2 mb-8 w-full">
        <h4 className="px-2 text-xl font-bold text-navy-700 dark:text-white">
          General Information
        </h4>
        <p className="mt-2 px-2 text-base text-gray-600">
         You're looking for information on the NjabuloJ/Njabulo-Jb GitHub repository. This repository appears to be associated with a WhatsApp bot, which is a chatbot designed to interact with users on the WhatsApp platform.

        *Key Features:*

        *Multi-Device Support*: The bot can be used across multiple devices.
        *AI-Powered*: The bot utilizes AI technology to generate human-like responses.
        *Customizable*: The bot offers various commands that can be used to customize its behavior.
        *Real-Time Messaging*: The bot can process messages in real-time.
        </p>
      </div>
      {/* Cards */}
      <div className="grid grid-cols-2 gap-4 px-2">
        <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600">Organization</p>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            Simmmple Web LLC
          </p>
        </div>

        <div className="flex flex-col justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600">Birthday</p>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            20 May 2005
          </p>
        </div>
      </div>

      {/* Social Media Buttons */}
      <div className="flex justify-center gap-4 mt-8">
        <a href="https://wa.me/message/LPAUQUUGPLBOE1" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-green-500 p-3 hover:bg-green-600">
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://www.facebook.com/profile.php?id=100094314013209" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-blue-600 p-3 hover:bg-blue-700">
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" alt="Facebook" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://www.instagram.com/njabulojb710?igsh=ZXZrOGs3bXN2MHBr" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-pink-500 p-3 hover:bg-pink-600">
            <img src="https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg" alt="Instagram" className="w-6 h-6" />
          </button>
        </a>
        <a href="https://whatsapp.com/channel/0029VbAckOZ7tkj92um4KN3u" target="_blank" rel="noopener noreferrer">
          <button className="flex items-center justify-center rounded-full bg-blue-400 p-3 hover:bg-blue-500">
            <img src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg" alt="Telegram" className="w-6 h-6" />
          </button>
        </a>
      </div>
    </Card>
  );
};

export default General;
